import {
    AdditionalBusinessInfoForm,
    BankInformationForm,
    BusinessOwnersForm,
    DBAForm,
    LegalForm,
    SalesProfileForm
} from "../../models/nuvei-application.model";
import {
    ExistingDocuments,
    FormErrors,
    validateAdditionalBusinessInfoForm, validateBankInformationForm, validateBusinessOwnersForm,
    validateDBAForm, validateDocumentFiles,
    validateLegalForm, validateSalesProfileForm
} from "../../helpers/nuvei/nuvei-form-validation";

export function formProgress(
    documentData: {
        documents: ExistingDocuments,
        hasPreviousPaymentProcessorInForm?: boolean
    },
    legalForm: LegalForm,
    dbaForm: DBAForm,
    additionalBusinessInfoForm: AdditionalBusinessInfoForm,
    salesProfileForm: SalesProfileForm,
    businessOwnersForm: BusinessOwnersForm,
    bankInformationForm: BankInformationForm
) {
    const results = [
        documentsProgress(documentData.documents, documentData.hasPreviousPaymentProcessorInForm),
        legalFormProgress(legalForm),
        dbaFormProgress(dbaForm),
        additionalBusinessInfoFormProgress(additionalBusinessInfoForm),
        salesProfileFormProgress(salesProfileForm),
        businessOwnersFormProgress(businessOwnersForm),
        bankInformationFormProgress(bankInformationForm),
    ];
    const total = results.reduce((acc, curr) => {
        acc.required += curr.required;
        acc.errors += curr.errors;
        return acc;
    }, { required: 0, errors: 0 });
    return total.errors / total.required;
}

export function legalFormProgress(form: LegalForm) {
    const errors = validateLegalForm(form);
    return { required: 13, errors: errorsCount(errors) };
}

export function dbaFormProgress(form: DBAForm) {
    const errors = validateDBAForm(form);
    return { required: 6, errors: errorsCount(errors) };
}

export function additionalBusinessInfoFormProgress(form: AdditionalBusinessInfoForm) {
    const errors = validateAdditionalBusinessInfoForm(form);
    return { required: 6, errors: errorsCount(errors) };
}

export function salesProfileFormProgress(form: SalesProfileForm) {
    const errors = validateSalesProfileForm(form);
    return { required: 4, errors: errorsCount(errors) };
}

export function businessOwnersFormProgress(form: BusinessOwnersForm) {
    const errors = validateBusinessOwnersForm(form);
    const result = { required: 1, errors: 0 };
    for(const ownerErrors of errors.owners!) {
        if(ownerErrors) {
            result.required += 11;
            result.errors = errorsCount(ownerErrors);
        }
    }
    if(typeof errors.guarantor === 'string')
        result.errors++;

    return result;
}

export function bankInformationFormProgress(form: BankInformationForm) {
    const errors = validateBankInformationForm(form);
    return { required: 3, errors: errorsCount(errors) };
}


export function documentsProgress(documents: ExistingDocuments, hasPreviousPaymentProcessorInForm?: boolean) {
    const errors = validateDocumentFiles(documents, hasPreviousPaymentProcessorInForm);
    return { required: hasPreviousPaymentProcessorInForm ? 3 : 2, errors: errorsCount(errors) };
}

function errorsCount<O>(errors: FormErrors<O>) {
    return Object.values(errors).reduce((acc: number, curr) => typeof curr === 'string' ? acc + 1 : acc, 0);
}